"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _GlobalFooter = _interopRequireDefault(require("./GlobalFooter"));
var __jsx = _react.default.createElement;
var ComponentEditConfig = {
  emptyLabel: 'Global Footer',
  isEmpty: function isEmpty(props) {
    return !props;
  }
};
var Component = function Component(props) {
  return __jsx(_GlobalFooter.default, props);
};
var _default = Component;
exports.default = _default;
(0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/globalfooter')(Component, ComponentEditConfig);